/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { AddressDto } from "./address-dto";
import { LienHolderDto } from "./lien-holder-dto";

/**
 *
 * @export
 * @interface CreateFarmRequest
 */
export interface CreateFarmRequest {
  /**
   *
   * @type {string}
   * @memberof CreateFarmRequest
   */
  doingBusinessAs: string;
  /**
   *
   * @type {AddressDto}
   * @memberof CreateFarmRequest
   */
  address: AddressDto;
  /**
   *
   * @type {string}
   * @memberof CreateFarmRequest
   */
  phoneNumber: string;
  /**
   *
   * @type {string}
   * @memberof CreateFarmRequest
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof CreateFarmRequest
   */
  stateOfOrganization: CreateFarmRequestStateOfOrganizationEnum;
  /**
   *
   * @type {Array<LienHolderDto>}
   * @memberof CreateFarmRequest
   */
  lienHolders: Array<LienHolderDto>;
}

/**
 * @export
 * @enum {string}
 */
export enum CreateFarmRequestStateOfOrganizationEnum {
  Arizona = "ARIZONA",
  Minnesota = "MINNESOTA",
  Nebraska = "NEBRASKA",
  NewMexico = "NEW_MEXICO",
  NorthDakota = "NORTH_DAKOTA",
  SouthDakota = "SOUTH_DAKOTA",
}
